(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trading247-repair-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('repair-directory')) {
    customElements.define('repair-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.form = this.querySelector('[data-repair-form]');
        this.status = this.querySelector('[data-repair-status]');
        this.results = this.querySelector('[data-repair-results]');
        this.offers = this.querySelector('[data-repair-offers]');
        this.form.addEventListener('submit', (event) => { event.preventDefault(); const data = new FormData(this.form); this.load(data.get('location'), data.get('country')); });
      }
      async load(locationValue, countryValue) {
        const location = String(locationValue || '').trim();
        const country = String(countryValue || '').trim().toUpperCase();
        if (!location || !/^[A-Z]{2}$/.test(country)) { this.form.reportValidity(); return; }
        this.status.textContent = this.dataset.loading;
        this.results.replaceChildren();
        this.offers.replaceChildren(); this.offers.hidden = true;
        const endpoint = new URL(this.dataset.endpoint, window.location.origin);
        endpoint.searchParams.set('location', location); endpoint.searchParams.set('country', country); endpoint.searchParams.set('radius', this.dataset.radius); endpoint.searchParams.set('limit', this.dataset.limit);
        try { const response = await fetch(endpoint, { headers: { Accept: 'application/json' } }); if (response.status === 404) { this.status.textContent = this.dataset.locationNotFound; return; } if (!response.ok) throw new Error('request_failed'); const payload = await response.json(); this.render(payload.results || []); this.renderOffers(payload.affiliate_offers || []); }
        catch (error) { this.status.textContent = this.dataset.unavailable; }
      }
      renderOffers(items) {
        if (!items.length) return;
        const title = document.createElement('h2'); title.textContent = this.dataset.affiliateTitle;
        const copy = this.text(this.dataset.affiliateCopy); copy.className = 'repair-directory__offers-copy';
        const list = document.createElement('div'); list.className = 'repair-directory__offer-list';
        items.forEach((item) => { const link = this.link(item.url, `${item.label} — ${item.partner}`); link.className = 'repair-directory__offer'; link.rel = 'sponsored nofollow noopener'; const disclosure = document.createElement('span'); disclosure.className = 'repair-directory__disclosure'; disclosure.textContent = item.disclosure; link.append(disclosure); list.append(link); });
        this.offers.append(title, copy, list); this.offers.hidden = false;
      }
      render(items) {
        this.results.replaceChildren();
        if (!items.length) { this.status.textContent = this.dataset.noResults; return; }
        this.status.textContent = ''; items.forEach((item) => this.results.append(this.card(item)));
      }
      card(item) {
        const article = document.createElement('article'); article.className = 'repair-directory__card';
        const title = document.createElement('h2'); title.textContent = item.name; article.append(title);
        article.append(this.text(item.category_name), this.text(item.full_address || item.address), this.text(`${item.distance_miles} ${this.dataset.miles}`));
        if (item.phone) article.append(this.text(`${this.dataset.phone}: ${item.phone}`));
        if (item.email) article.append(this.text(`${this.dataset.email}: ${item.email}`));
        const actions = document.createElement('div'); actions.className = 'repair-directory__actions';
        if (item.phone) { const number = String(item.phone).replace(/[^+\d]/g, ''); if (number) { const call = this.link(`tel:${number}`, this.dataset.call, false); call.classList.add('repair-directory__link--call'); actions.append(call); } }
        if (item.email) { const email = this.link(`mailto:${item.email}`, this.dataset.sendEmail, false); actions.append(email); }
        if (item.website_url) { const website = this.link(item.website_url, this.dataset.website); website.classList.add('repair-directory__link--primary'); website.rel = item.commercial_status === 'sponsored' ? 'sponsored nofollow noopener' : 'noopener'; actions.append(website); }
        const address = [item.address, item.city, item.region, item.postal_code, item.country_code].filter(Boolean).join(', ');
        const destination = Number.isFinite(Number(item.latitude)) && Number.isFinite(Number(item.longitude)) ? `${item.latitude},${item.longitude}` : address;
        const directions = this.link(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(destination)}`, this.dataset.directions, false);
        directions.dataset.directions = 'true'; actions.append(directions);
        article.append(actions); return article;
      }
      text(value) { const paragraph = document.createElement('p'); paragraph.className = 'repair-directory__meta'; paragraph.textContent = value; return paragraph; }
      link(url, label, newWindow = true) { const anchor = document.createElement('a'); anchor.className = 'repair-directory__link'; anchor.href = url; anchor.textContent = label; if (newWindow) { anchor.target = '_blank'; anchor.rel = 'noopener'; } return anchor; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
